import { render, staticRenderFns } from "./UploadRecordPopupConfirm.vue?vue&type=template&id=5603a83c&scoped=true&"
import script from "./UploadRecordPopupConfirm.vue?vue&type=script&lang=js&"
export * from "./UploadRecordPopupConfirm.vue?vue&type=script&lang=js&"
import style0 from "./UploadRecordPopupConfirm.vue?vue&type=style&index=0&id=5603a83c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5603a83c",
  null
  
)

export default component.exports